import { Blueprint } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

export interface PlaceholderPageProps {
  title: string;
  testId?: string;
}

export function PlaceholderPage({ title, testId }: PlaceholderPageProps) {
  return (
    <section data-testid={testId} aria-labelledby="placeholder-title">
      <p className="mb-1.5 font-titulo text-rotulo uppercase text-fg-dim">
        {ptBR.placeholder.eyebrow}
      </p>
      <h1 id="placeholder-title" className="text-display-md text-fg">
        {title}
      </h1>
      <Blueprint className="mt-sc-4 p-sc-6">
        <p className="text-body-sm text-fg-muted">{ptBR.placeholder.underConstruction}</p>
      </Blueprint>
    </section>
  );
}
